/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowTemplatesControllerFindOneQueryResponse, WorkflowTemplatesControllerFindOnePathParams, WorkflowTemplatesControllerFindOneQueryParams, WorkflowTemplatesControllerFindOne400, WorkflowTemplatesControllerFindOne401, WorkflowTemplatesControllerFindOne403, WorkflowTemplatesControllerFindOne404 } from "../../models/workflowsController/WorkflowTemplatesControllerFindOne";

function getWorkflowTemplatesControllerFindOneUrl(id: WorkflowTemplatesControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/workflow-templates/${id}` as const }  
  return res
}

/**
 * @summary Get a workflow template by id
 * {@link /api/v1/workflow-templates/:id}
 */
export async function workflowTemplatesControllerFindOne(id: WorkflowTemplatesControllerFindOnePathParams["id"], params?: WorkflowTemplatesControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<WorkflowTemplatesControllerFindOneQueryResponse, ResponseErrorConfig<WorkflowTemplatesControllerFindOne400 | WorkflowTemplatesControllerFindOne401 | WorkflowTemplatesControllerFindOne403 | WorkflowTemplatesControllerFindOne404>, unknown>({ method : "GET", url : getWorkflowTemplatesControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}